import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Utility functions for the stellarcloud application
 */

/**
 * Formats a string by replacing placeholders with values
 * @example
 * formatString("Hello {name}!", { name: "World" }) // "Hello World!"
 */
export const formatString = (template: string, values: Record<string, string | number>): string => {
  return template.replace(/{(\w+)}/g, (match, key) => {
    return values[key]?.toString() ?? match;
  });
};

/**
 * Truncates a string to a specified length and adds an ellipsis
 * @example
 * truncateString("Hello World", 5) // "Hello..."
 */
export const truncateString = (str: string, maxLength: number): string => {
  if (str.length <= maxLength) return str;
  return `${str.slice(0, maxLength)}...`;
}; 